@if (loaderState === LoaderState.InProgress || loaderState === LoaderState.Error) {
  <app-global-loader
    [title]="loaderContent?.title"
    [message]="loaderContent?.message"></app-global-loader>
} @else {
  <router-outlet></router-outlet>
}

<!-- ngx-sonner toaster with enhanced configuration -->
<ngx-sonner-toaster
  position="bottom-left"
  [duration]="3000"
  [closeButton]="true"
  [richColors]="false"
  [expand]="false"
  [visibleToasts]="5" />

<!-- Server Side Events watcher -->
@if (user) {
  <app-sse></app-sse>
}

<app-overlay-layout
  *ngIf="showShortcutsOverlay$ | async"
  [action]="true"
  [added]="false"
  [overlay_footer]="false"
  (onClose)="onShortcutsOverlayClose()"
  [collapseTitle]="'Close Shortcuts'">
  <ng-container overlayContent>
    <div class="values d-flex align-items-start flex-column w-100 spacing-24">
      <h3 class="h3-bold primary-100">Keyboard Shortcuts</h3>

      @for (category of shortcutCategories; track category) {
        <div class="shortcut-category w-100 d-flex flex-column spacing-8">
          <h4 class="h4-bold primary-60 cursor">{{ category.name }}</h4>
          <div class="d-flex flex-column">
            @for (shortcut of category.shortcuts; track shortcut) {
              <app-overlay-value-data
                class="w-100"
                [title]="shortcut.name"
                [title_icon]="'keyboard'"
                [readOnly]="true"
                [valueType]="'text'"
                [emptyskeletonLabel]="'shortcut'"
                [currentValue]="shortcut.shortcut"
                [valueOptions]="[]"
                [isDropdown]="false">
              </app-overlay-value-data>
            }
          </div>
        </div>
      }
    </div>
  </ng-container>
</app-overlay-layout>
